import { itemKey } from "@/utils/menuGroups";

// Naziv i ključ stavke menija, isto kao što je stari bočni meni računao naziv.
export default {
  methods: {
    menuKey(item) {
      return itemKey(item);
    },
    // "Lokacija" se prikazuje samo kad je korisnik prenosiv (kao do sada); sve ostalo je $t(naslov).
    menuVisible(item) {
      if (item.title === "Локација") {
        return this.$store.state.user.user?.is_transferable == 1;
      }
      return true;
    },
    menuLabel(item) {
      if (item._translate) {
        return this.translate(item.title);
      }
      if (item.title === "Локација" || item.title === "Lokacija") {
        return this.translate(item.title);
      }
      return this.$t(item.title);
    },
    menuItemActive(item) {
      const to = item.to || {};
      const route = this.$route || {};
      return (to.name && route.name === to.name) || (to.path && route.path === to.path);
    },
  },
};
